import { render, staticRenderFns } from "./packSizeSetEdit.vue?vue&type=template&id=06f78371&scoped=true&"
import script from "./packSizeSetEdit.vue?vue&type=script&lang=js&"
export * from "./packSizeSetEdit.vue?vue&type=script&lang=js&"
import style0 from "./packSizeSetEdit.vue?vue&type=style&index=0&id=06f78371&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f78371",
  null
  
)

component.options.__file = "packSizeSetEdit.vue"
export default component.exports